import { AGG_TYPES_BY_SECTION_AND_DISPLAY, AggType, ColumnDisplayType, LabelValuePair, VisualizationType } from '@ddv/models';

import { DropZoneId } from '../models/drop-zone-id';

export function getAggregationDropdownList(
    displayType: ColumnDisplayType,
    zoneId: DropZoneId,
    visualizationType: VisualizationType,
): LabelValuePair<AggType>[] {
    if (zoneId === 'tooltip') {
        return AGG_TYPES_BY_SECTION_AND_DISPLAY.tooltip[displayType] ?? [];
    }

    const chartType = ['PIE_CHART', 'DONUT_CHART'].includes(visualizationType) ? 'circle' : 'chart';
    return AGG_TYPES_BY_SECTION_AND_DISPLAY[chartType][displayType] ?? [];
}
